import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Short from 'Components/Format/DateFormat/Short';
import EditButtonLink from 'Components/Blueprint/UI/EditButtonLink';
import ImageHeading from '../ImageHeading';

const Wills = ({ wills, editLink }) => (
  <td className="wills">
    <ImageHeading className="wills">
      Wills
      {editLink && (<EditButtonLink
        title="Edit Wills"
        to={editLink}
      />)}
    </ImageHeading>
    {wills.length > 0 ? (
      wills.map(will => (
        <div className="will item" key={`${will.id}will`}>
          <div className="name">{will.attributes.testator}</div>
          {will.attributes.dateExecuted !== '' && (
            <div>
              Executed:&nbsp;
              <Short date={will.attributes.dateExecuted} />
            </div>
          )}
          {will.attributes.personalRepresentative !== '' && (
            <div>
              Personal Rep:&nbsp;
              {will.attributes.personalRepresentative}
            </div>
          )}
          {will.attributes.guardian !== '' && (
            <div>
              Guardian:&nbsp;
              {will.attributes.guardian}
            </div>
          )}
          {will.attributes.trustee !== '' && (
            <div>
              Trustee:&nbsp;
              {will.attributes.trustee}
            </div>
          )}
        </div>
      ))
    ) : (
      <Fragment>
        <p>No wills.</p>
      </Fragment>
    )}
  </td>
);

Wills.propTypes = {
  wills: PropTypes.array.isRequired,
  editLink: PropTypes.string,
};
Wills.defaultProps = {
  editLink: '',
};

export default Wills;
